import { ref } from 'vue'

const showAlternateHeader = ref(false)
const heroRef = ref(null)
let observer = null

export function useRateConnectOnboardingData() {
  const initScrollObserver = (heroElement, isEligible) => {
    if (!heroElement || !isEligible) return

    heroRef.value = heroElement

    observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          showAlternateHeader.value = !entry.isIntersecting
        })
      },
      {
        threshold: 0,
        rootMargin: '-50px 0px',
      }
    )

    observer.observe(heroElement)
  }

  const cleanup = () => {
    if (observer && heroRef.value) {
      observer.unobserve(heroRef.value)
      observer.disconnect()
    }
  }

  const resetShowAlternateHeader = () => {
    showAlternateHeader.value = false
  }

  return {
    showAlternateHeader,
    initScrollObserver,
    cleanup,
    resetShowAlternateHeader,
  }
}
